import axios from 'axios';
// The public phone confirmation has no session or financial credentials.
// Local homologation links may be opened on another device in the same LAN.
export function assistantPublicBase(configured,location){
 const base=new URL(configured||location.origin,location.origin);
 const local=['localhost','127.0.0.1','[::1]'].includes(base.hostname);
 const privateHost=/^(?:192\.168\.|10\.|172\.(?:1[6-9]|2\d|3[01])\.)/.test(location.hostname);
 if(local&&privateHost)base.hostname=location.hostname;
 return base.origin;
}
const publicApi=axios.create({baseURL:assistantPublicBase(process.env.REACT_APP_BACKEND_URL,window.location),withCredentials:false,timeout:12000});
export default publicApi;
